
<div class="chart-container">
    
    <mat-card>
    

      <div class="chart-width">

      <canvas id="chartInvBedNd"></canvas>
      </div>
    </mat-card>
  </div>
  